import styled from 'styled-components';

export const RowMonitoring = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const ColMonitoring = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: auto;
  padding: 0 1rem;
  flex-wrap: wrap;
`;
